function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Tooltip } from 'antd';
import { CopyOutlined, CheckCircleTwoTone } from '@ant-design/icons';

var CopyButton = (_ref) => {
  var {
    id = 'copy-button',
    textToCopy,
    title = 'Copy',
    buttonStyle,
    icon = /*#__PURE__*/React.createElement(CopyOutlined, null)
  } = _ref;
  var [copied, setCopied] = useState(false);
  useEffect(() => {
    setCopied(false);
  }, [textToCopy]);
  var copyIcon = copied ? /*#__PURE__*/React.createElement(CheckCircleTwoTone, {
    twoToneColor: "#52c41a"
  }) : icon;

  var btnStyle = _objectSpread(_objectSpread({}, buttonStyle), {}, {
    icon: copyIcon
  });

  var copyText = copied ? 'Copied!' : title;
  return /*#__PURE__*/React.createElement(Tooltip, {
    key: id,
    title: copyText
  }, /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: textToCopy,
    onCopy: () => setCopied(true)
  }, /*#__PURE__*/React.createElement(Button, btnStyle, buttonStyle.buttonText)));
};

export default CopyButton;